import { Link } from "react-router-dom";

function TopHead() {
    return (
        <div className="top-section">
            <Link to="/">
                <div className="company-name">CHI BRANDER INC</div>
                <div className="logo">
                    <img src="logo.png" alt="CHI BRANDER INC Logo"/>
                </div>
            </Link>
        </div>
    );
}

export default TopHead;